
    import '/opt/buildhome/repo/packages/x/components/mermaid/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["mermaid-demo-basic","mermaid-demo-custom-header","mermaid-demo-header-actions","mermaid-demo-with-xmarkdown","mermaid-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/mermaid/index.zh-CN.md?type=demo')
};